var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplimentaryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 58.154,
    viewBox: "0 0 72 58.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_room_service",
    d: "M30.692,5v5.538h5.538v6.1a32.729,32.729,0,0,0-29.9,29.9H3v5.538H8.538v5.538H3v5.538H75V57.615H69.462V52.077H75V46.538H71.668a32.729,32.729,0,0,0-29.9-29.9v-6.1h5.538V5ZM39,21.615c14.343,0,25.687,10.972,27.135,24.923H11.865C13.313,32.587,24.657,21.615,39,21.615ZM14.077,52.077H63.923v5.538H14.077Z",
    transform: "translate(-3 -5)",
    fill: "#002b5a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplimentaryIcon);
export default __webpack_public_path__ + "static/media/complimentaryIcon.0f605651a255a3e63f389cacc7aa24a2.svg";
export { ForwardRef as ReactComponent };